module.exports = __webpack_public_path__ + "static/media/WIN-BNB.1e7878d6.svg";